import React from 'react';

/**
 * Merkezi yazdırma yardımcı fonksiyonları
 * Tüm sayfalarda tutarlı yazdırma deneyimi sağlar
 */

// Şirket başlık şablonu
export const getCompanyHeader = (settings, title) => {
  const logoUrl = settings?.main_logo || settings?.logo_url || '';
  
  return `
    <div style="text-align: center; margin-bottom: 20px; padding-bottom: 15px; border-bottom: 2px solid #1e3a5f;">
      ${logoUrl ? `<img src="${logoUrl}" alt="Logo" style="max-height: 60px; margin-bottom: 10px;" />` : ''}
      <h1 style="margin: 0; color: #1e3a5f; font-size: 24px; font-weight: bold;">${settings?.company_name || 'ROTA Maritime Agency'}</h1>
      <p style="margin: 5px 0 0 0; color: #666; font-size: 12px;">${settings?.company_address || ''}</p>
      ${settings?.company_phone ? `<p style="margin: 3px 0 0 0; color: #666; font-size: 12px;">Tel: ${settings.company_phone}</p>` : ''}
      ${settings?.company_email ? `<p style="margin: 3px 0 0 0; color: #666; font-size: 12px;">E-posta: ${settings.company_email}</p>` : ''}
      ${title ? `<h2 style="margin: 15px 0 0 0; color: #333; font-size: 18px;">${title}</h2>` : ''}
    </div>
  `;
};

// Belge bilgi bölümü
export const getDocumentInfo = (fields) => {
  const rows = fields.map(field => `
    <tr>
      <td style="padding: 5px 10px; font-weight: 600; color: #475569; width: 150px;">${field.label}:</td>
      <td style="padding: 5px 10px; color: #1f2937;">${field.value || '-'}</td>
    </tr>
  `).join('');
  
  return `
    <table style="width: 100%; margin-bottom: 20px; border-collapse: collapse;">
      ${rows}
    </table>
  `;
};

// Tablo şablonu
export const getDataTable = (headers, rows, options = {}) => {
  const { showFooter = false, footerContent = '' } = options;
  
  const headerCells = headers.map(h => `
    <th style="padding: 10px; text-align: ${h.align || 'left'}; background: #f8fafc; border-bottom: 2px solid #e2e8f0; color: #475569; font-size: 12px; font-weight: 600;">
      ${h.label}
    </th>
  `).join('');
  
  const bodyRows = rows.map((row, idx) => {
    const cells = row.map((cell, cellIdx) => `
      <td style="padding: 8px 10px; border-bottom: 1px solid #f1f5f9; text-align: ${headers[cellIdx]?.align || 'left'}; font-size: 12px;">
        ${cell}
      </td>
    `).join('');
    return `<tr style="background: ${idx % 2 === 0 ? '#fff' : '#fafafa'};">${cells}</tr>`;
  }).join('');
  
  return `
    <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;">
      <thead><tr>${headerCells}</tr></thead>
      <tbody>${bodyRows}</tbody>
      ${showFooter ? `<tfoot>${footerContent}</tfoot>` : ''}
    </table>
  `;
};

// Toplam bölümü
export const getTotalSection = (items, currency = 'USD') => {
  const rows = items.map(item => `
    <div style="display: flex; justify-content: space-between; padding: 8px 0; ${item.isTotal ? 'border-top: 2px solid #1e3a5f; margin-top: 10px; padding-top: 15px;' : 'border-bottom: 1px solid #e2e8f0;'}">
      <span style="font-weight: ${item.isTotal ? '700' : '500'}; color: ${item.isTotal ? '#1e3a5f' : '#475569'}; font-size: ${item.isTotal ? '16px' : '13px'};">
        ${item.label}
      </span>
      <span style="font-weight: ${item.isTotal ? '700' : '500'}; color: ${item.isTotal ? '#059669' : '#1f2937'}; font-size: ${item.isTotal ? '16px' : '13px'};">
        ${typeof item.value === 'number' ? item.value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : item.value} ${currency}
      </span>
    </div>
  `).join('');
  
  return `
    <div style="background: #f8fafc; padding: 15px 20px; border-radius: 8px; margin-top: 20px;">
      ${rows}
    </div>
  `;
};

// Alt bilgi şablonu
export const getFooter = (settings, notes) => {
  return `
    <div style="margin-top: 30px; padding-top: 20px; border-top: 1px solid #e2e8f0;">
      ${notes ? `<div style="margin-bottom: 15px; padding: 10px; background: #fffbeb; border-radius: 6px; font-size: 12px; color: #92400e;"><strong>Notlar:</strong> ${notes}</div>` : ''}
      <div style="text-align: center; color: #9ca3af; font-size: 11px;">
        <p style="margin: 5px 0;">${settings?.company_name || 'ROTA Maritime Agency'}</p>
        ${settings?.tax_office && settings?.tax_number ? `<p style="margin: 5px 0;">Vergi Dairesi: ${settings.tax_office} - Vergi No: ${settings.tax_number}</p>` : ''}
        <p style="margin: 5px 0;">Bu belge ${new Date().toLocaleDateString('tr-TR')} tarihinde oluşturulmuştur.</p>
      </div>
    </div>
  `;
};

// Yazdırma penceresi aç
export const openPrintWindow = (content, title = 'Yazdır') => {
  const printWindow = window.open('', '_blank');
  if (!printWindow) {
    alert('Pop-up engelleyicinizi kontrol edin!');
    return;
  }
  
  printWindow.document.write(`
    <!DOCTYPE html>
    <html>
    <head>
      <title>${title}</title>
      <meta charset="UTF-8">
      <style>
        @media print {
          body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
          @page { margin: 15mm; }
        }
        body {
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
          margin: 0;
          padding: 20px;
          color: #1f2937;
          line-height: 1.5;
        }
        table { page-break-inside: auto; }
        tr { page-break-inside: avoid; page-break-after: auto; }
      </style>
    </head>
    <body>
      ${content}
    </body>
    </html>
  `);
  
  printWindow.document.close();
  
  // Resimler yüklendikten sonra yazdır
  setTimeout(() => {
    printWindow.print();
  }, 500);
};

// Fatura/Proforma yazdırma şablonu
export const printInvoiceDocument = (document, settings, type = 'invoice') => {
  const typeLabel = type === 'invoice' ? 'FATURA' : 'PROFORMA FATURA';
  const numberLabel = type === 'invoice' ? 'Fatura No' : 'Proforma No';
  
  const header = getCompanyHeader(settings, typeLabel);
  
  const info = getDocumentInfo([
    { label: numberLabel, value: document.number },
    { label: 'Tarih', value: new Date(document.created_at).toLocaleDateString('tr-TR') },
    { label: 'Müşteri', value: document.client_name },
    { label: 'Gemi', value: document.vessel_name },
    { label: 'Para Birimi', value: document.currency }
  ]);
  
  const tableHeaders = [
    { label: 'Hizmet', align: 'left' },
    { label: 'Miktar', align: 'center' },
    { label: 'Birim', align: 'center' },
    { label: 'Birim Fiyat', align: 'right' },
    { label: 'KDV', align: 'center' },
    { label: 'Toplam', align: 'right' }
  ];
  
  const tableRows = (document.lines || []).map(line => [
    line.description,
    line.quantity,
    line.unit || 'ADET',
    line.unit_price?.toLocaleString('en-US', { minimumFractionDigits: 2 }) || '0.00',
    line.has_vat ? `%${line.vat_rate || 20}` : '-',
    line.total?.toLocaleString('en-US', { minimumFractionDigits: 2 }) || '0.00'
  ]);
  
  const table = getDataTable(tableHeaders, tableRows);
  
  const totals = getTotalSection([
    { label: 'Ara Toplam', value: document.subtotal || document.total },
    ...(document.vat_amount > 0 ? [{ label: 'KDV', value: document.vat_amount }] : []),
    { label: 'GENEL TOPLAM', value: document.total, isTotal: true }
  ], document.currency);
  
  const footer = getFooter(settings, document.notes);
  
  const content = `
    <div style="max-width: 800px; margin: 0 auto; padding: 20px;">
      ${header}
      ${info}
      ${table}
      ${totals}
      ${footer}
    </div>
  `;
  
  openPrintWindow(content, `${typeLabel} - ${document.number}`);
};

// Ödeme makbuzu yazdırma şablonu
export const printPaymentReceipt = (payment, settings) => {
  const header = getCompanyHeader(settings, 'ÖDEME MAKBUZU');
  
  const info = getDocumentInfo([
    { label: 'Makbuz No', value: `PAY-${payment.id?.substring(0, 8).toUpperCase()}` },
    { label: 'Tarih', value: new Date(payment.payment_date).toLocaleDateString('tr-TR') },
    { label: 'Müşteri', value: payment.client_name },
    { label: 'Fatura No', value: payment.invoice_number || '-' },
    { label: 'Ödeme Yöntemi', value: getPaymentMethodLabel(payment.payment_method) },
    ...(payment.bank_name ? [{ label: 'Banka', value: payment.bank_name }] : [])
  ]);
  
  const amount = `
    <div style="background: #f0fdf4; border: 2px solid #86efac; border-radius: 12px; padding: 25px; text-align: center; margin: 30px 0;">
      <div style="color: #166534; font-size: 14px; margin-bottom: 10px;">Ödeme Tutarı</div>
      <div style="color: #059669; font-size: 36px; font-weight: 700;">
        ${payment.amount?.toLocaleString('en-US', { minimumFractionDigits: 2 })} ${payment.currency || 'USD'}
      </div>
    </div>
  `;
  
  const footer = getFooter(settings, payment.notes);
  
  const content = `
    <div style="max-width: 600px; margin: 0 auto; padding: 20px;">
      ${header}
      ${info}
      ${amount}
      ${footer}
    </div>
  `;
  
  openPrintWindow(content, `Ödeme Makbuzu - ${payment.client_name}`);
};

// Müşteri cari hesap yazdırma şablonu
export const printClientLedger = (client, transactions, settings, summary) => {
  const header = getCompanyHeader(settings, 'CARİ HESAP EKSTRESİ');
  
  const info = getDocumentInfo([
    { label: 'Müşteri', value: client.name },
    { label: 'Şirket', value: client.company || '-' },
    { label: 'Rapor Tarihi', value: new Date().toLocaleDateString('tr-TR') }
  ]);
  
  const tableHeaders = [
    { label: 'Tarih', align: 'left' },
    { label: 'Belge No', align: 'left' },
    { label: 'Açıklama', align: 'left' },
    { label: 'Borç', align: 'right' },
    { label: 'Alacak', align: 'right' },
    { label: 'Bakiye', align: 'right' }
  ];
  
  let runningBalance = 0;
  const tableRows = transactions.map(t => {
    const debit = t.type === 'invoice' ? t.amount : 0;
    const credit = t.type === 'payment' ? t.amount : 0;
    runningBalance += debit - credit;
    
    return [
      new Date(t.date).toLocaleDateString('tr-TR'),
      t.document_number || '-',
      t.description,
      debit > 0 ? debit.toLocaleString('en-US', { minimumFractionDigits: 2 }) : '-',
      credit > 0 ? credit.toLocaleString('en-US', { minimumFractionDigits: 2 }) : '-',
      runningBalance.toLocaleString('en-US', { minimumFractionDigits: 2 })
    ];
  });
  
  const table = getDataTable(tableHeaders, tableRows);
  
  const totals = getTotalSection([
    { label: 'Toplam Fatura', value: summary?.totalInvoiced || 0 },
    { label: 'Toplam Ödeme', value: summary?.totalPaid || 0 },
    { label: 'BAKİYE', value: summary?.balance || 0, isTotal: true }
  ], 'USD');
  
  const footer = getFooter(settings);
  
  const content = `
    <div style="max-width: 900px; margin: 0 auto; padding: 20px;">
      ${header}
      ${info}
      ${table}
      ${totals}
      ${footer}
    </div>
  `;
  
  openPrintWindow(content, `Cari Hesap - ${client.name}`);
};

// Ödeme yöntemi etiketleri
const getPaymentMethodLabel = (method) => {
  const labels = {
    'bank_transfer': 'Banka Havalesi',
    'cash': 'Nakit',
    'credit_card': 'Kredi Kartı',
    'check': 'Çek'
  };
  return labels[method] || method || '-';
};

export default {
  getCompanyHeader,
  getDocumentInfo,
  getDataTable,
  getTotalSection,
  getFooter,
  openPrintWindow,
  printInvoiceDocument,
  printPaymentReceipt,
  printClientLedger
};
